import React from "react";
import { Rifm } from 'rifm';
import Question from '../components/Question'
import Address from '../components/Address'
import QuoteStepBase, { mapVehicleStepProps } from '../components/QuoteStepBase'
import VehicleTitle from '../components/VehicleTitle'
import { InputGroup, Button, Form, FormControl, Modal, Collapse, Alert } from 'react-bootstrap'
import { IAppState } from "../state/interfaces";
import { IAddress, IAddressChangeResult, IQuoteApiClient, IPaths, IToolTipOption } from "../classes/Domain";
import { connect } from "react-redux";
import { QUOTE_STEPS, YES_NO, COMPONENTS, QUOTE_QUESTIONS, MILEAGE_QUESTIONS } from "../AppConstants";
import QuoteStep from "./QuoteStepLayout";
import Utilities from "../classes/Utilities";
import { IVehicleStepProps, IQuoteStepState } from "../components/interfaces";
import { validationUtils } from "../validation/Validation";
import ReactLoading from 'react-loading';
import ButtonContinue from "../components/ButtonContinue";
import QuoteActions from "../state/appActions";


interface IHowYouDriveProps extends IVehicleStepProps {
    vehiclesCount: number,
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

interface IState extends IQuoteStepState {
    vehicleUse: string,
    valueMiles: string,
    mileage: string,
    parkAtHome: string,
    garagingAddress: IAddress | null,
    updatingStore: boolean,
    addVehicleClick: boolean,
    continueClick: boolean,
    errors: any,
    invalidGaragingAddress: boolean,
    showMoreOptionsForm: boolean,
    moreOptionsFormDisplayed: boolean;
}

class HowYouDrive extends QuoteStepBase<IHowYouDriveProps, IState> {
    constructor(props: IHowYouDriveProps) {
        super(props);

        this.next = this.next.bind(this);
        this.onCarAddressChanged = this.onCarAddressChanged.bind(this);
        this.openMoreOptionsForm = this.openMoreOptionsForm.bind(this);
        this.handleGetMoreOptions = this.handleGetMoreOptions.bind(this);
        this.handleCloseMoreOptionsForm = this.handleCloseMoreOptionsForm.bind(this);

        this.state = {
            vehicleUse: "",
            valueMiles: "",
            mileage: "",
            parkAtHome: "",
            garagingAddress: null,
            updatingStore: false,
            addVehicleClick: false,
            continueClick: false,
            errors: null,
            invalidGaragingAddress: false,
            moreOptionsFormDisplayed: false,
            showMoreOptionsForm: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();

        const _this = this;
        const businessUse = document.getElementsByClassName("radioInline")[2];

        businessUse.addEventListener("mouseover", function (event) {
            if (_this.state.moreOptionsFormDisplayed) {
                _this.openMoreOptionsForm();
            }
        });
    }

    subscribeToValidation() {
        validationUtils.subscribeToValidationFailure(this.props.id,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, continueClick: false, addVehicleClick: false, errors: validationData });
            });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const vehicle = nextProps.vehicle;
            const nextState = {
                ...prevState,
                vehicleUse: vehicle.vehicleUse,
                valueMiles: vehicle.valueMiles,
                mileage: vehicle.mileage,
                parkAtHome: vehicle.parkAtHome,
                garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === vehicle.parkAtHome ? null : vehicle.garagingAddress
            };

            nextProps.meta.propsSource = "";
            return nextState;
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();
        if (QUOTE_QUESTIONS.YES_NO.NO === this.state.parkAtHome && null !== this.state.garagingAddress){
            this.setState({ updatingStore: true, continueClick: true, addVehicleClick: false }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };

                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(this.props.PATHS.ABOUT_YOU, "")),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }else{
            this.setState({ updatingStore: true, continueClick : true, addVehicleClick : false }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };
    
                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(this.props.PATHS.ABOUT_YOU, "")),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }
    }

    callbackFunctionUse = (childData: string) => {
        if (childData === QUOTE_QUESTIONS.VEHICLE_USE.BUISNESS)
        {
            if (!this.state.showMoreOptionsForm) {
                this.openMoreOptionsForm();
                this.setState({ vehicleUse: QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING });
            }
        }
        else if (childData === QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING)
        {
            this.setState({ vehicleUse : childData, valueMiles: "" });
        }
        else if (childData === QUOTE_QUESTIONS.VEHICLE_USE.PERSONAL)
        {
            this.setState({ vehicleUse: childData, valueMiles: "2500", mileage: "" });
        }
        else
        {
            this.setState({ vehicleUse: childData, valueMiles: "8500" });
        }
    };

    callbackFunctionMiles = (childData: string) => {
        let currMiles = Number(this.state.valueMiles);

        switch (childData) {
            case MILEAGE_QUESTIONS.MILEAGE.LESS_THAN_THREE:
                if (currMiles > 6595 && currMiles < 7595) {
                    this.setState({ mileage: childData, valueMiles: currMiles.toString() });
                }
                else {
                    this.setState({ mileage: childData, valueMiles: "6595" });
                }
                break;
            case MILEAGE_QUESTIONS.MILEAGE.FIVE:
                if (currMiles > 7595 && currMiles < 10095) {
                    this.setState({ mileage: childData, valueMiles: currMiles.toString() });
                }
                else {
                    this.setState({ mileage: childData, valueMiles: "7595" });
                }
                break;
            case MILEAGE_QUESTIONS.MILEAGE.TEN:
                if (currMiles > 10095 && currMiles < 15095) {
                    this.setState({ mileage: childData, valueMiles: currMiles.toString() });
                }
                else {
                    this.setState({ mileage: childData, valueMiles: "10095" });
                }
                break;
           // case QUESTIONS.MILEAGE.FIFTEEN: this.setState({ mileage: childData, valueMiles:"11500"});
             //   break;
            case MILEAGE_QUESTIONS.MILEAGE.TWENTY:
                if (currMiles > 15095) {
                    this.setState({ mileage: childData, valueMiles: currMiles.toString() });
                }
                else {
                    this.setState({ mileage: childData, valueMiles: "15095" });
                }
                break;
            //case QUESTIONS.MILEAGE.TWENTY_FIVE: this.setState({ mileage: childData, valueMiles:"18500"});
            //    break;
            //case QUESTIONS.MILEAGE.THIRTY: this.setState({ mileage: childData, valueMiles:"20900"});
        }
    };

    callbackFunctionAddress = (childData: string) => {
        this.setState({ parkAtHome: childData });
    };

    onCarAddressChanged(result: IAddressChangeResult) {
        this.setState({
            ...this.state, garagingAddress: result.address, invalidGaragingAddress: !(result.hasOwnProperty("isValid") && result.isValid)
        })
    }

    onAddVehicleClick() {
        if (QUOTE_QUESTIONS.YES_NO.NO === this.state.parkAtHome
            && this.state.garagingAddress
            && Utilities.isAddressFilled(this.state.garagingAddress)) {
            this.setState({ updatingStore: true, continueClick: false, addVehicleClick: true }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };

                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(this.props.PATHS.VEHICLE_YMM, this.props.vehiclesCount.toString())),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }else{
            this.setState({ updatingStore: true, continueClick: false, addVehicleClick: true }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };
    
                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(this.props.PATHS.VEHICLE_YMM, this.props.vehiclesCount.toString())),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }
    }

    openMoreOptionsForm() {
        this.setState({ ...this.state, showMoreOptionsForm: true, moreOptionsFormDisplayed: true });
    }

    handleCloseMoreOptionsForm() {
        this.setState({ ...this.state, showMoreOptionsForm: false });
    }

    handleGetMoreOptions() {
        this.handleCloseMoreOptionsForm();
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><VehicleTitle vehicle={this.props.vehicle} /></div>

                <Form noValidate className={null != this.state.errors ? "is-invalid" : ""}>
                    {
                        this.props.stateCode === "CA"
                            ?
                            <Question
                                name="vehicleUse"
                                selected={this.callbackFunctionUse}
                                selectedValue={this.state.vehicleUse}
                                error={validationUtils.hasValidationErrorFor(this.state.errors, "vehicleUse") ? this.state.errors["vehicleUse"][0] : ""}
                                items={[QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING, /*QUOTE_QUESTIONS.VEHICLE_USE.PERSONAL,*/ QUOTE_QUESTIONS.VEHICLE_USE.BUISNESS/*, QUOTE_QUESTIONS.VEHICLE_USE.FARMING, QUOTE_QUESTIONS.VEHICLE_USE.OTHER*/]}
                                lable="What is this car's primary use?"
                                tooltip={{ title: "Business Use", content: "Business or artisan use includes but is not limited to transporting or carrying tools, supplies, equipment, building materials, or persons from home to work or between work locations for a business purpose, or to render services at such location." } as IToolTipOption}
                            />
                            : null
                    }

                    {
                        this.props.stateCode === "TX"
                            ?
                            <Question
                                name="vehicleUse"
                                selected={this.callbackFunctionUse}
                                selectedValue={this.state.vehicleUse}
                                error={validationUtils.hasValidationErrorFor(this.state.errors, "vehicleUse") ? this.state.errors["vehicleUse"][0] : ""}
                                items={[QUOTE_QUESTIONS.VEHICLE_USE.PERSONAL, QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING, QUOTE_QUESTIONS.VEHICLE_USE.BUISNESS]}
                                lable="What is this car's primary use?"
                                tooltip={{ title: "Business Use", content: "Incidental business use is acceptable for private passenger vehicles used in sales, service or trade occupation. Vehicle must be titled in an individual's name. There is a surcharge. Please call (833)966-9273 and we can help you." } as IToolTipOption}
                            />
                            : null
                    }

                    <Question
                        name="mileage"
                        error={validationUtils.hasValidationErrorFor(this.state.errors, "mileage") ? this.state.errors["mileage"][0] : ""}
                        style={{ display: this.state.vehicleUse === QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING ? '' : 'none' }}
                        selected={this.callbackFunctionMiles}
                        selectedValue={this.state.mileage}
                        items={[MILEAGE_QUESTIONS.MILEAGE.LESS_THAN_THREE, MILEAGE_QUESTIONS.MILEAGE.FIVE, MILEAGE_QUESTIONS.MILEAGE.TEN, MILEAGE_QUESTIONS.MILEAGE.TWENTY, /*QUESTIONS.MILEAGE.TWENTY, QUESTIONS.MILEAGE.TWENTY_FIVE, QUESTIONS.MILEAGE.THIRTY*/]}
                        lable="About how many miles each way?" />

                    <Form.Label>Annual mileage</Form.Label>

                    <Rifm
                        accept={/\d/g}
                        format={Utilities.formatNumber}
                        value={this.state.valueMiles}
                        onChange={(v: any) => { this.setStateValue(v.toString().replace(/[^\d]/gi, ""), "valueMiles") }}>
                        {({ value, onChange }) => (
                            <InputGroup className="mb-3">
                                <FormControl
                                    placeholder="ex. 12,000"
                                    aria-describedby="basic-addon2"
                                    onChange={onChange}
                                    value={value}
                                    className={null != this.state.errors ? (validationUtils.hasValidationErrorFor(this.state.errors, "valueMiles") ? "is-invalid" : "is-valid") : ""}
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                />
                                <InputGroup.Append>
                                    <InputGroup.Text id="basic-addon2">miles</InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        )}
                    </Rifm>

                    {validationUtils.hasValidationErrorFor(this.state.errors, "valueMiles")
                        ? <Form.Control.Feedback type="invalid">
                            {this.state.errors["valueMiles"][0]}
                        </Form.Control.Feedback>
                        : null
                    }

                    <Question
                        name="parkAtHome"
                        selected={this.callbackFunctionAddress}
                        error={validationUtils.hasValidationErrorFor(this.state.errors, "parkAtHome") ? this.state.errors["parkAtHome"][0] : ""}
                        selectedValue={this.state.parkAtHome}
                        items={[QUOTE_QUESTIONS.YES_NO.YES, QUOTE_QUESTIONS.YES_NO.NO]}
                        lable="Do you park this car at your home address?" />

                    <Collapse in={YES_NO.NO === this.state.parkAtHome}>
                        <div>
                            <Alert variant={"warning"}>
                                <h5 className="text-center">
                                    <strong className="text-uppercase">We do not cover loss</strong>
                                    <br />
                                    to your insured automobile while it is being regularly garaged more than two days per week at a location other than the address of the named insured. 
                                </h5>
                            </Alert>
                        </div>
                    </Collapse>
                </Form>

                <div className="btnContainer">
                    <Button
                        className="btnAddVehicle"
                        onClick={() => { this.onAddVehicleClick() }}
                        disabled={this.state.updatingStore || this.state.invalidGaragingAddress || (this.state.parkAtHome === YES_NO.NO)}>{this.state.updatingStore && this.state.addVehicleClick ? <ReactLoading type={"spin"} className="continue-loading" color={"#389BFF"} height={'20px'} width={'20px'} /> : <i className="fas fa-plus"></i>} Add another car</Button>
                    <div className="orText"><p>or</p></div>
                    <ButtonContinue
                        disabled={this.state.updatingStore || this.state.invalidGaragingAddress || (this.state.parkAtHome === YES_NO.NO)}
                        showLoading={this.state.updatingStore && this.state.continueClick}
                        onClick={this.next} />
                </div>

                <Modal show={this.state.showMoreOptionsForm} onHide={this.handleCloseMoreOptionsForm}>
                    <Modal.Header closeButton>
                        <Modal.Title>Business Option</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-center font-weight-bolder">
                            Please call us at
                        </p>
                        <div className="text-center">
                            <a href={"tel:(424)559-5751"} className="btnContinue btn btn-primary btn-sm for-mobile">Call Us <i className="fas fa-phone"></i></a>
                            <span className="big-label text-center for-desktop">(424)559-5751</span>
                        </div>
                        <p className="text-center font-weight-bolder">
                            or email us at <a href="mailto:Onward_Sales@onwardins.com">Onward_Sales@onwardins.com</a>
                        </p>
                        <p className="text-center font-weight-bolder">
                            for customized coverage
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonContinue
                            className="btn-sm"
                            disabled={this.state.updatingStore}
                            label="Close"
                            showLoading={this.state.updatingStore}
                            onClick={this.handleGetMoreOptions} />
                    </Modal.Footer>
                </Modal>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IVehicleStepProps) => {
    var props = mapVehicleStepProps(state, ownProps);
    props["vehiclesCount"] = state.vehicles.length;
    props["stateCode"] = state.stateCode;

    return props;
}

let mapDispatch = (dispatch: any, ownProps: IHowYouDriveProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.HOW_YOU_DRIVE)),
        updateAppState: (update) => dispatch(quoteActions.updateVehicle(update.quoteUid, update.vehicle, QUOTE_STEPS.HOW_YOU_DRIVE))
    };
};

export default connect(mapProps, mapDispatch)(HowYouDrive);
